//request
/**
 * 网络请求方法
 * Created by su0012004  on 2020/8/20.
 */

import AxiosInst from '@/components/libs/axiosInst';
import Qs from 'qs';
 class request {

}
request.getUrlParam = function(key) {//获取当前页面url中的参数
     var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
     var result = window.location.search.substr(1).match(reg);
     return result ? decodeURIComponent(result[2]) : '';
 }

/**
 * 微信接口专用
 * @param {Object} url
 * @param {Object} data
 *
 *
 *
 */
 request.wx_get = function(url, data,baseURL = '/api_weixin') {
         return new Promise((resolve, reject) => {
           // AxiosInst.defaults.baseURL  =  '/api_weixin',
             AxiosInst.get(url, {
                 baseURL: baseURL,//'/api_weixin',
                 params: data,
        headers:{
            'wx-client-href':location.href,
            'Access-Control-Allow-Origin': '*',
        }
    },

    ).then((response) => {
                 resolve(response.data);
             }).catch((response) => {
                 console.log('服务请求出错', response);
                 reject(response);
             });
         })
     }


    /**
     * GET 请求 无提示
     * @param url 请求URL
     * @param data 请求数据
     * @returns {Promise}
     */
request.get = function(url, data,headers = {} ) {

        return new Promise((resolve, reject) => {

            AxiosInst.get(url, {
                params: data,
                headers: headers
            }).then((response) => {
                resolve(response.data);
            }).catch((response) => {
                console.log('服务请求出错', response);
                reject(response);
            });
        })
    }
    /**
     * POST 请求 无提示
     * @param url 请求URL
     * @param data 请求数据
     * @returns {Promise}
     */
request.post = function(url, data,headers = {} ) {
        return new Promise((resolve, reject) => {
            AxiosInst.post(url,data, {headers:headers} ).then((response) => {
                resolve(response.data);
            }).catch((response) => {
                console.log('服务请求出错', response);
                reject(response);
            })
        })
    }
    
request.upload_post = function(url, data,headers = {},baseURL = '/service_img') {

  let config = {
            baseURL:baseURL,
            headers:{'Content-Type':'multipart/form-data'} //这里是重点，需要和后台沟通好请求头，Content-Type不一定是这个值
          }; //添加请求头
 
        return new Promise((resolve, reject) => {
            AxiosInst.post(url,data,config).then((response) => {
                resolve(response.data);
            }).catch((response) => {
                console.info('服务请求出错 post', response);
                reject(response);
            })
        })
    }
    
    
    
    
    /**
     * put 请求 无提示
     * @param url 请求URL
     * @param data 请求数据
     * @returns {Promise}
     */
request.put = function(url, data,headers = {} ) {
        return new Promise((resolve, reject) => {
            AxiosInst.put(url, data,{headers:headers} )
            .then((response) => {
                resolve(response.data);
            }).catch((response) => {
                console.log('服务请求出错', response);
                reject(response);
            })
        })
    }
 request.r_delete = function(url, data = {} ,headers = {} ) {
       console.info('request.delete  请求数据:: ', data );
         return new Promise((resolve, reject) => {
             AxiosInst.delete(url, {data: Qs.stringify(data)}  ,headers ).then((response) => {
                 resolve(response.data);
             }).catch((response) => {
                 console.log('服务请求出错', response);
                 reject(response);
             })
         })
     }

request.delete = function(url, data = {} ,headers = {} ) {
      console.info('request.delete  请求数据:: ', data );
        return new Promise((resolve, reject) => {
            AxiosInst.delete(url, {data: Qs.stringify(data)}  ,headers ).then((response) => {
                resolve(response.data);
            }).catch((response) => {
                console.log('服务请求出错', response);
                reject(response);
            })
        })
    }

export default request;



// WEBPACK FOOTER //
// ./src/components/libs/request.js